// Module-scope open/close flag for the single, app-root-mounted Care Reminders dialog, so the
// Care Hub Settings entry card and the Home "Manage Care Reminders" action open the exact same
// dialog with no per-caller state and no duplicated settings logic. Mirrors the existing
// pwaInstallVisibility store pattern (module flag + Set of listeners + useSyncExternalStore).
// In-memory only; a fresh page load starts closed.

let open = false;
const listeners = new Set<() => void>();

function notify() {
  for (const listener of listeners) {
    listener();
  }
}

export function openCareRemindersDialog() {
  if (!open) {
    open = true;
    notify();
  }
}

export function closeCareRemindersDialog() {
  if (open) {
    open = false;
    notify();
  }
}

export function getCareRemindersDialogOpen() {
  return open;
}

export function subscribeToCareRemindersDialog(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function __resetCareRemindersDialogForTests() {
  open = false;
  listeners.clear();
}
